import { createSelector } from "@reduxjs/toolkit";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectSearchQueries } from "views/logic/slices/viewSelectors";
const selectQueryIds = createSelector(selectSearchQueries, (queries) => queries.map((q) => q.id).toOrderedSet());
const useQueryIds = () => useViewsSelector(selectQueryIds);
export default useQueryIds;
